import script from "./Deliveries.vue?vue&type=script&lang=ts&setup=true"
export * from "./Deliveries.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__